import update from 'immutability-helper';

export default function setGettingEventActivityData(state, action) {
  // console.log('SET_GETTING_EVENT_ACTIVITY_DATA', action)

  return update(state, {
    gettingChart: {
      $set: true,
    },
    renderChart: {
      $set: false,
    },
  });
}
